import { BASEURL } from '../../../../utils/config';

export const GET_ALL_TICKETS_URL = `${BASEURL}/noc_ticket/getall/1`;
export const CREATE_TICKET_URL = `${BASEURL}/noc_ticket`;
export const FILTER_TICKETS_URL = `http://api.tizeti.com:5000/api/v1/noc_ticket/ticket/filter`
